import { candidateAPI } from '../services/api';

export function buildJourneyEvent(type, extra = {}) {
  return {
    type,
    at: new Date().toISOString(),
    ...extra,
  };
}

export async function recordJourneyEvent(type, extra = {}) {
  const event = buildJourneyEvent(type, extra);
  const payload = { journeyEvents: event };
  if (type === 'onboarding_started') {
    payload.onboardingStartedAt = event.at;
  }
  if (type === 'onboarding_completed') {
    payload.onboardingCompletedAt = event.at;
  }
  try {
    await candidateAPI.updatePreferences(payload);
  } catch (error) {
    // Journey UX must not fail if event persistence is unavailable.
  }
  return event;
}
